import i18n from '../i18n';
// @childrenClass
  // @class*: Clase de css a la que se hace referencia
  // @valueState*: Valor en el state global al que hace referencia
  // @defaultValue*: Valor default en el state global
  // @disabledEdit: Seccion solo para cambio de posicion pero no editable en su informacion
  // @isRemove: Se puede remover la seccion, Boolean
  // @valueRemove: Valor a validar para remover la seccion, Boolean
  // @onlyOptions: No se reemplazara nada de texto, solamente agregara los paremtros indicados
  // @isImg: Es referente a etiqueta img, Boolean
  // @isImgBackground: Es referente a setear una imagen mediante style.background, Boolean
  // @options: [ARRAY] Toda aquella propiedad que pueda recibir el elemento
  // @isCustomText: Referente a el componente editor donde puedes utilizar tags Html
  // @isTextArea: Referente a el componente textArea
  // @isCarousel: Referente a un slider
  // @optionCarousel:
  // @isBullet: Referente a componente Bullet
  // @optionBullet: Opciones para pintar los inidcator del bullet
  // @isPaginator: Referente a mostrar paginador
  // @optionPaginator: Opciones para configurar los items por paginador
  // @isTabsDescription: Referente a mostrar tabs
  // @optionTabsDescripcion: Opciones para configurar los items por tabs
  
  // @isFilterComponent: Referente a presentar componente de filtros dinamicamente en micrositio

  // @containerOneClass: Solo cuando es una item contenedor que a su ves tiene childrenClass. Se hace referencia a la clase primaria de cada hijo
export const catalogoClass = [
  {
    titleSection: 'Banner principal',
    description: 'Presenta una imagen de fondo, titulo, descripción, 1 boton',
    img: '/assets/img/banner-primary.png',
    componentName: 'BannerMain',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-main-banner',
      childrenClass: [
        { class: 'sct-main-banner-title', valueState: 'bannerMain.$language.title', defaultValue: '' },
        { class: 'sct-main-banner-description', valueState: 'bannerMain.$language.description', defaultValue: '' },
        {
          class: 'sct-main-banner-btn',
          valueState: 'bannerMain.$language.btnText',
          defaultValue: '',
          isRemove: true,
          valueRemove: 'bannerMain.hasBnt',
          options: [
            { property: 'href', valueState: 'bannerMain.btnHref', defaultValue: '_blank'  },
            { property: 'target', valueState: 'bannerMain.btnTarget', defaultValue: ''  }
        ]
        },
        {
          class: 'sct-main-banner-img',
          valueState: 'bannerMain.backgroundImg',
          defaultValue: [],
          isImg: true,
        },
      ],
    },
  },
  {
    titleSection: 'Banner imagen derecha',
    description: 'Presenta una imagen derecha, descripción, 1 boton',
    img: '/assets/img/banner-img-r.png',
    componentName: 'BannerImgRigthForm',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-banner-img-rigth',
      childrenClass: [
        { class: 'sct-banner-img-rigth-title', valueState: 'bannerImgR.$language.title', defaultValue: '' },
        { class: 'sct-banner-img-rigth-description', valueState: 'bannerImgR.$language.description', defaultValue: '', isCustomText: true },
        {
          class: 'sct-banner-img-rigth-button',
          valueState: 'bannerImgR.$language.btnText',
          defaultValue: '',
          isRemove: true,
          valueRemove: 'bannerImgR.hasBnt',
          options: [
            { property: 'href', valueState: 'bannerImgR.btnHref', defaultValue: '_blank'  },
            { property: 'target', valueState: 'bannerImgR.btnTarget', defaultValue: ''  }
        ]
        },
        {
          class: 'sct-banner-img-rigth-img',
          valueState: 'bannerImgR.backgroundImg',
          defaultValue: [],
          isImg: true,
        },
      ],
    },
  },
  {
    titleSection: 'Banner imagen izquierda',
    description: 'Presenta una imagen izquierda, descripción, 1 boton',
    img: '/assets/img/banner-img-l.png',
    componentName: 'BannerImgLeftForm',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-banner-img-left',
      childrenClass: [
        { class: 'sct-banner-img-left-title', valueState: 'bannerImgL.$language.title', defaultValue: '' },
        { class: 'sct-banner-img-left-description', valueState: 'bannerImgL.$language.description', defaultValue: '', isCustomText: true },
        {
          class: 'sct-banner-img-left-button',
          valueState: 'bannerImgL.$language.btnText',
          defaultValue: '',
          isRemove: true,
          valueRemove: 'bannerImgL.hasBnt',
          options: [
            { property: 'href', valueState: 'bannerImgL.btnHref', defaultValue: '_blank'  },
            { property: 'target', valueState: 'bannerImgL.btnTarget', defaultValue: ''  }
        ]
        },
        {
          class: 'sct-banner-img-left-img',
          valueState: 'bannerImgL.backgroundImg',
          defaultValue: [],
          isImg: true,
        },
      ],
    },
  },
  {
    titleSection: 'Descipcion imagen derecha',
    description: 'Presenta una imagen derecha, descripción principal y descipcion inferior, 1 boton',
    img: '/assets/img/description-img.png',
    componentName: 'DescriptionImgRigthForm',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-description-img-rigth',
      childrenClass: [
        { class: 'sct-description-img-rigth-title', valueState: 'descriptionImgR.$language.title', defaultValue: '' },
        { class: 'sct-description-img-rigth-des', valueState: 'descriptionImgR.$language.description', defaultValue: '', isCustomText: true },
        { class: 'sct-description-img-rigth-des-alt', valueState: 'descriptionImgR.$language.descriptionAlt', defaultValue: '', isCustomText: true },
        {
          class: 'btn sct-description-img-rigth-button',
          valueState: 'descriptionImgR.$language.btnText',
          defaultValue: '',
          isRemove: true,
          valueRemove: 'descriptionImgR.hasBnt',
          options: [
            { property: 'href', valueState: 'descriptionImgR.btnHref', defaultValue: '_blank'  },
            { property: 'target', valueState: 'descriptionImgR.btnTarget', defaultValue: ''  }
        ]
        },
        {
          class: 'sct-description-img-rigth-img',
          valueState: 'descriptionImgR.backgroundImg',
          defaultValue: [],
          isImg: true,
        },
      ],
    },
  },
  {
    titleSection: 'Cards Flotantes',
    description: 'Agregar un conjunto de bloques de información que incluyan una imagen, titulo y una descripción, con un titulo principal',
    img: '/assets/img/cards-flotantes.png',
    componentName: 'FloatingCardsForm',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-floating-cards',
      childrenClass: [
        { class: 'sct-floating-cards-title', valueState: 'floatingCards.$language.title', defaultValue: '' },
        {
          class: 'sct-floating-cards-container',
          valueState: 'floatingCards.cards',
          defaultValue: [],
          containerOneClass: 'sct-floating-cards-item',
          childrenClass: [
            { class: 'sct-floating-cards-item-title', valueState: 'floatingCards.cards[$index].$language.title', defaultValue: '' },
            { class: 'sct-floating-cards-item-description', valueState: 'floatingCards.cards[$index].$language.description', defaultValue: '', isTextArea: true},
            {
              class: 'sct-floating-cards-item-img',
              valueState: 'floatingCards.cards[$index].backgroundImg',
              defaultValue: [],
              isImg: true,
            }
          ],
        },
      ],
    },
  },
  {
    titleSection: 'Categoria documentos',
    description: 'Agregar un conjunto de cards que correspondan a las categorias de documentos',
    img: '/assets/img/categoria-documentos.png',
    componentName: 'DocumentsCards',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-cards-doc',
      childrenClass: [
        {
          class: 'sct-cards-doc-container',
          valueState: 'documentsCards.cards',
          defaultValue: [],
          containerOneClass: 'sct-cards-doc-item',
          childrenClass: [
            { class: 'sct-cards-doc-item-title', valueState: 'documentsCards.cards[$index].$language.title', defaultValue: '' },
            { class: 'sct-cards-doc-item-description', valueState: 'documentsCards.cards[$index].$language.description', defaultValue: '', isTextArea: true},
            {
              class: 'sct-cards-doc-item-button-link',
              valueState: '',
              onlyOptions: true,
              options: [
                { property: 'th:href', valueState: 'documentsCards.cards[$index].pathRedirect', defaultValue: ''  }
            ]
            },
            {
              class: 'sct-cards-doc-item-button-txt',
              valueState: 'documentsCards.cards[$index].$language.btnText',
              defaultValue: '',
            },
            {
              class: 'sct-cards-doc-item-img',
              valueState: 'documentsCards.cards[$index].backgroundImg',
              defaultValue: [],
              isImg: true,
            }
          ],
        },
      ],
    },
  },
  {
    titleSection: 'Procesos',
    description: 'Configura un conjunto de cards relacionadas a el flujo de procesos',
    img: '/assets/img/formulario-procesos.png',
    componentName: 'ProcesssCards',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-processes',
      childrenClass: [
        {
          class: 'sct-processes-container',
          valueState: 'process.cards',
          defaultValue: [],
          containerOneClass: 'sct-processes-item',
          childrenClass: [
            { class: 'sct-processes-item-title', valueState: 'process.cards[$index].$language.title', defaultValue: '' },
            { class: 'sct-processes-item-description', valueState: 'process.cards[$index].$language.description', defaultValue: '', isTextArea: true },
            {
              class: 'sct-processes-item-button-link',
              valueState: '',
              onlyOptions: true,
              options: [
                { property: 'th:href', valueState: 'process.cards[$index].processUrl', defaultValue: ''  },
                { property: 'data-process-id', valueState: 'process.cards[$index].processId', defaultValue: ''  },
                { property: 'disabled', valueState: 'process.cards[$index].isDisabledDocumento', defaultValue: false  },
                { property: 'hide', valueState: 'process.cards[$index].showBtnDoc', defaultValue: false },
            ]
            },
            {
              class: 'sct-processes-item-button-status',
              onlyOptions: true,
              isRemove: true,
              valueRemove: 'process.cards[$index].showBtnStatus',
              options: [
                { property: 'th:href', valueState: 'process.cards[$index].processStatus', defaultValue: ''  },
                { property: 'data-process-id', valueState: 'process.cards[$index].processId', defaultValue: ''  },
            ]
            },
            {
              class: 'sct-processes-item-button-report',
              valueState: '',
              onlyOptions: true,
              isRemove: true,
              valueRemove: 'process.cards[$index].showBtnReport',
              options: [
                { property: 'th:href', valueState: 'process.cards[$index].processUrlReport', defaultValue: '', isLink: true  },
                { property: 'data-process-id', valueState: 'process.cards[$index].processId', defaultValue: ''  },
                { property: 'disabled', valueState: 'process.cards[$index].isDisabledReport', defaultValue: false  },
            ]
            },
            {
              class: 'sct-processes-item-button-txt',
              valueState: 'process.cards[$index].$language.btnText',
              defaultValue: '',
            },
            {
              class: 'sct-processes-item-img',
              valueState: 'process.cards[$index].backgroundImg',
              defaultValue: [],
              isImg: true,
            }
          ],
        },
      ],
    },
  },
  {
    titleSection: 'Componente 3 bloques',
    description: 'Agregar un conjunto de bloques de información',
    img: '/assets/img/bloque-3.png',
    componentName: 'Blocks3',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-3blocks',
      childrenClass: [
        {
          class: 'sct-3blocks-container',
          valueState: 'blocks3.cards',
          defaultValue: [],
          containerOneClass: 'sct-3blocks-item',
          childrenClass: [
            { class: 'sct-3blocks-item-title', valueState: 'blocks3.cards[$index].$language.title', defaultValue: '' },
            { class: 'sct-3blocks-item-description', valueState: 'blocks3.cards[$index].$language.description', defaultValue: '', isTextArea: true },
            {
              class: 'sct-3blocks-item-link',
              valueState: '',
              onlyOptions: true,
              options: [
                { property: 'href', valueState: 'blocks3.cards[$index].btnHref', defaultValue: ''  },
                { property: 'target', valueState: 'blocks3.cards[$index].btnTarget', defaultValue: '_blank'  }
            ]
            },
            {
              class: 'sct-3blocks-item-btntxt',
              valueState: 'blocks3.cards[$index].$language.btnText',
              defaultValue: '',
            },
            {
              class: 'sct-3blocks-item-img',
              valueState: 'blocks3.cards[$index].backgroundImg',
              defaultValue: [],
              isImg: true,
            }
          ],
        },
      ],
    },
  },
  {
    titleSection: 'Banner codigo de etica',
    description: 'Presenta una imagen de fondo, titulo, descripción, 1 boton',
    img: '/assets/img/banner-codigo.png',
    componentName: 'BannerCodeEthics',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-banner-code-ethics',
      childrenClass: [
        { class: 'sct-banner-code-ethics-title', valueState: 'bannerCodeEthics.$language.title', defaultValue: '' },
        { class: 'sct-banner-code-ethics-description', valueState: 'bannerCodeEthics.$language.description', defaultValue: '', isTextArea: true},
        {
          class: 'sct-banner-code-ethics-btn',
          valueState: 'bannerCodeEthics.$language.btnText',
          defaultValue: '',
          // isRemove: true,
          // valueRemove: 'bannerCodeEthics.hasBnt',
          options: [
            { property: 'id', valueState: 'bannerCodeEthics.documentId', defaultValue: ''  },
            { property: 'data-documentid', valueState: 'bannerCodeEthics.documentId', defaultValue: ''  }
        ]
        },
        {
          class: 'sct-banner-code-ethics-img',
          valueState: 'bannerCodeEthics.backgroundImg',
          defaultValue: [],
          isImg: true,
        },
      ],
    },
  },
  {
    titleSection: 'Slider logos',
    description: 'Agregar un conjunto de imagenes con ligas',
    img: '/assets/img/sitios-interes.png',
    componentName: 'SlidersLogos',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sliders-logos',
      childrenClass: [
        { class: 'sliders-logos-title', valueState: 'slidersLogos.$language.title', defaultValue: '' },

        {
          class: 'sliders-logos-container',
          valueState: 'slidersLogos.cards',
          defaultValue: [],
          containerOneClass: 'sliders-logos-item',
          childrenClass: [
            {
              class: 'sliders-logos-item-link',
              valueState: '',
              onlyOptions: true,
              options: [
                { property: 'href', valueState: 'slidersLogos.cards[$index].btnHref', defaultValue: ''  },
            ]
            },
            {
              class: 'sliders-logos-item-img',
              valueState: 'slidersLogos.cards[$index].backgroundImg',
              defaultValue: [],
              isImg: true,
            }
          ],
        },
      ],
    },
  },
  {
    titleSection: 'Bullets',
    description: 'Agrega un conjunto de bloques de informacion.',
    img: '/assets/img/bullets.png',
    componentName: 'Bullets',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-bullets',
      childrenClass: [
        {
          class: 'sct-bullets-content',
          valueState: 'bullets.cards',
          defaultValue: [],
          containerOneClass: 'sct-bullets-item',
          isBullet: true,
          optionBullet : {
            classIndicator: 'sct-bullets-indicators',
            classitemDynamic: 'cPage',
            classTabs: 'sct-bullets-content-tabs',
            classTabsItem: 'sct-bullets-content-tabs-item'
          },
          childrenClass: [
            { class: 'sct-bullets-item-title', valueState: 'bullets.cards[$index].$language.title', defaultValue: '' },
            // { class: 'sct-bullets-item-title-fake', valueState: 'bullets.cards[$index].$language.title', defaultValue: '' },
            { class: 'sct-bullets-item-description', valueState: 'bullets.cards[$index].$language.description', defaultValue: '', isCustomText: true },
            {
              class: 'sct-bullets-item-img',
              valueState: 'bullets.cards[$index].img',
              defaultValue: [],
              isImg: true,
            },
          ],
        },
      ],
    },
  },
  {
    titleSection: 'Tabs',
    description: 'Agrega un conjunto de Tabs con contenido, donde incluye un titulo secundario, imagen, y texto abierto',
    img: '/assets/img/tabsDescription.png',
    componentName: 'TabsDescription',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-tabs-descripcion',
      childrenClass: [
        {
          class: 'sct-tabs-descripcion',
          valueState: 'tabsDescripcion.cards',
          defaultValue: [],
          containerOneClass: 'sct-tabs-descripcion-item',
          isTabsDescription: true,
          optionTabsDescripcion : {
            // classIndicator: 'sct-tabs-descripcion-indicators',
            // classitemDynamic: 'cPage',
            classTabs: 'sct-tabs-descripcion-content-tabs',
            classTabsItem: 'sct-tabs-descripcion-content-tabs-item'
          },
          childrenClass: [
            {
              class: 'sct-tabs-descripcion-item-data-title',
              valueState: '',
              onlyOptions: true,
              options: [
                { property: 'data-title', valueState: 'tabsDescripcion.cards[$index].$language.title', defaultValue: ''  },
              ]
            },
            { class: 'sct-tabs-descripcion-item-subtitle', valueState: 'tabsDescripcion.cards[$index].$language.subtitle', defaultValue: '' },
            { class: 'sct-tabs-descripcion-item-description', valueState: 'tabsDescripcion.cards[$index].$language.description', defaultValue: '', isCustomText: true },
            {
              class: 'sct-tabs-descripcion-item-img',
              valueState: 'tabsDescripcion.cards[$index].img',
              defaultValue: [],
              isImg: true,
            },
          ],
        },
      ],
    },
  },
  {
    titleSection: 'Capacitate para el empleo',
    description: 'Capacitate para el empleo',
    img: '/assets/img/capacitate.png',
    componentName: 'CapacitateEmpleo',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-capacitate-empleo',
      childrenClass: [
        { class: 'sct-capacitate-empleo-title', valueState: 'capacitateEmpleo.$language.title', defaultValue: '' },
        { class: 'sct-capacitate-empleo-description', valueState: 'capacitateEmpleo.$language.description', defaultValue: '', isCustomText: true  },
        {
          class: 'sct-capacitate-empleo-img',
          valueState: 'capacitateEmpleo.backgroundImg',
          defaultValue: [],
          isImg: true,
        },
        {
          class: 'sct-capacitate-empleo-container-page',
          valueState: 'capacitateEmpleo.cards',
          defaultValue: [],
          containerOneClass: 'sct-capacitate-empleo-container-page-slider',
          containerParentPage: 'sct-capacitate-empleo-container-page-slider-content',
          isPaginator: true,
          optionPaginator : {
            itemsBySlider: 9,
            // classIndicator: 'sct-blocks-carrousel-indicators',
            classitem: 'sct-capacitate-empleo-container-page-slider-item',
            classitemDynamic: 'cPage',
          },
          childrenClass: [
            { class: 'sct-capacitate-empleo-container-page-slider-item-title', valueState: 'capacitateEmpleo.cards[$index].$language.title', defaultValue: '' },
            { class: 'sct-capacitate-empleo-container-page-slider-item-description', valueState: 'capacitateEmpleo.cards[$index].$language.description', defaultValue: '', isTextArea: true},
            {
              class: 'sct-capacitate-empleo-container-page-slider-item-link',
              valueState: '',
              onlyOptions: true,
              options: [
                { property: 'href', valueState: 'capacitateEmpleo.cards[$index].btnHref', defaultValue: ''  },
            ]
            },
            {
              class: 'sct-capacitate-empleo-container-page-slider-item-btntxt',
              valueState: 'capacitateEmpleo.cards[$index].$language.btnText',
              defaultValue: '',
            },
          ],
        },
      ],
    },
  },
  {
    titleSection: 'Documentos',
    description: 'Esto generara un bloque con la visualizacion de documentos',
    img: '/assets/img/documentos-filtros.png',
    componentName: 'isFilterComponent',
    containerClass: 'dynamic-elements-content',
    disabledEdit: true,
    isFilterComponent: true,
    parentClass: {
      class: 'sct-documents',
      childrenClass:[
      ]
    },
  },
  {
    titleSection: 'Documentos recientes',
    description: 'Componente para mostrar los ultimos documentos añadidos',
    img: '/assets/img/ultimos-documentos.PNG',
    componentName: 'UltimosDocumentosAgregadosComponent',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'sct-ultimos-documentos',
      childrenClass: [
        { class: 'sct-ultimos-documentos-title', valueState: 'ultimosDocumentos.$language.title', defaultValue: '' },
        { class: 'sct-ultimos-documentos-description', valueState: 'ultimosDocumentos.$language.description', defaultValue: '' },
      ],
    },
  },
  // {
  //   titleSection: 'Subsecciones',
  //   description: 'Esto es obligatorio para tu plantilla. Lista las subsecciones que forman parte de la sección',
  //   img: 'https://miro.medium.com/max/2560/1*_Jzj_A-hDj1GLxMDIXwhvQ.png',
  //   componentName: 'DocumentsForm',
  //   // containerClass: 'dynamic-elements-content',
  //   disabledEdit: true,
  //   parentClass: {
  //     class: 'sct-category',
  //     childrenClass:[]
  //   },
  // },
  // {
  //   titleSection: 'Banner',
  //   description: 'Presenta una imagen, descripción, 2 botones',
  //   img: 'https://static.vecteezy.com/system/resources/previews/000/271/404/non_2x/ux-ui-web-banner-vector.jpg',
  //   componentName: 'BannerForm',
  //   // containerClass: 'dynamic-elements-content',
  //   parentClass: {
  //     class: 'sct-banner',
  //     childrenClass: [
  //       { class: 'sct-banner-title', valueState: 'banner.$language.title', defaultValue: '' },
  //       { class: 'sct-banner-description', valueState: 'banner.$language.description', defaultValue: '', isCustomText: true },
  //       {
  //         class: 'sct-banner-btn',
  //         valueState: 'banner.$language.btnText',
  //         defaultValue: '',
  //         isRemove: true,
  //         valueRemove: 'banner.hasBnt',
  //         options: [
  //           { property: 'href', valueState: 'banner.btnHref', defaultValue: '_blank'  },
  //           { property: 'target', valueState: 'banner.btnTarget', defaultValue: ''  }
  //       ]
  //       },
  //       {
  //         class: 'sct-banner-background-img',
  //         valueState: 'banner.backgroundImg',
  //         defaultValue: [],
  //         isImgBackground: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   titleSection: 'Carousel',
  //   description: 'Puedes incluir desde 1 hasta N imágenes.',
  //   img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTzQG-1jGcvHrlH4Nap7nMPpzFnlrau9mQ9iA&usqp=CAU',
  //   componentName: 'CarouselForm',
  //   // containerClass: 'dynamic-elements-content',
  //   parentClass: {
  //     class: 'sct-carrousel',
  //     childrenClass: [
  //       {
  //         class: 'sct-carrousel-container',
  //         valueState: 'carousel.cards',
  //         defaultValue: [],
  //         containerOneClass: 'sct-carrousel-content-slider',
  //         isCarousel: true,
  //         optionCarousel : {
  //           itemsBySlider: 1,
  //           classIndicator: 'sct-carrousel-indicators',
  //           classitem: 'sct-carrousel-item'
  //         },
  //         childrenClass: [
  //           { class: 'sct-carrousel-title', valueState: 'carousel.cards[$index].$language.title', defaultValue: '' },
  //           { class: 'sct-carrousel-description', valueState: 'carousel.cards[$index].$language.description', defaultValue: '', isCustomText: true },
  //           {
  //             class: 'sct-carrousel-btn',
  //             valueState: 'carousel.cards[$index].$language.btnText',
  //             defaultValue: '',
  //             isRemove: true,
  //             valueRemove: 'carousel.cards[$index].hasBnt',
  //             options: [
  //               { property: 'href', valueState: 'carousel.cards[$index].btnHref', defaultValue: '_blank'  },
  //               { property: 'target', valueState: 'carousel.cards[$index].btnTarget', defaultValue: ''  }
  //             ]
  //           },
  //           {
  //             class: 'sct-carrousel-btn-seconday',
  //             valueState: 'carousel.cards[$index].$language.btnTextSecondary',
  //             defaultValue: '',
  //             isRemove: true,
  //             valueRemove: 'carousel.cards[$index].hasBntSecondary',
  //             options: [
  //               { property: 'href', valueState: 'carousel.cards[$index].btnHrefSecondary', defaultValue: '_blank'  },
  //               { property: 'target', valueState: 'carousel.cards[$index].btnTargetSecondary', defaultValue: ''  }
  //             ]
  //           },
  //           {
  //             class: 'sct-carrousel-background-img',
  //             valueState: 'carousel.cards[$index].backgroundImg',
  //             defaultValue: [],
  //             isImgBackground: true,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   titleSection: 'Preguntas Frecuentes',
  //   description: 'Agregar a tu plantilla un listado de preguntas y respuestas que pueden ayudar a los usuarios a comprender mejor la sección',
  //   img: 'https://blog.uxdivi.com/wp-content/uploads/sites/2/2021/03/tips-de-ui-para-diseno-web-6-1024x589.jpg',
  //   componentName: 'FrequentQuestionsForm',
  //   // containerClass: 'dynamic-elements-content',
  //   parentClass: {
  //     class: 'sct-faq',
  //     childrenClass: [
  //       {
  //         class: 'sct-faq-conteiner',
  //         valueState: 'frequentQuestions.cards',
  //         defaultValue: [],
  //         containerOneClass: 'sct-faq-item',
  //         isFrecuentQuestion: true,
  //         optionFrecuentQuestion: {
  //           classHeading: 'sct-faq-panel-heading',
  //           classCollapse: 'sct-faq-panel-collapse',
  //           classHref: 'sct-faq-question'
  //         },
  //         childrenClass: [
  //           { class: 'sct-faq-question', valueState: 'frequentQuestions.cards[$index].$language.question', defaultValue: '' },
  //           { class: 'sct-faq-answer', valueState: 'frequentQuestions.cards[$index].$language.answer', defaultValue: '', isCustomText: true },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   titleSection: 'Descripción de sección',
  //   description: 'Agrega una descripción con formato para que los usuarios puedan saber de que se trata la sección.',
  //   img: 'https://kiranworkspace.com/wp-content/uploads/edd/2020/12/service-section-1024x768.png',
  //   componentName: 'DescriptionForm',
  //   // containerClass: 'dynamic-elements-content',
  //   parentClass: {
  //     class: 'sct-description',
  //     childrenClass: [
  //       { class: 'sct-description-container', valueState: 'description.$language.description', defaultValue: '', isCustomText: true }
  //     ],
  //   },
  // },
  // {
  //   titleSection: 'Links Relacionados',
  //   description: 'Incluye a tu plantilla un listado de URLs que inviten al usuario a conocer más sobre el tema',
  //   img: 'https://freefrontend.com/assets/img/css-link-styles/link-styling-exploration-without-classes.png',
  //   componentName: 'RelatedLinksForm',
  //   // containerClass: 'dynamic-elements-content',
  //   parentClass: {
  //     class: 'sct-links',
  //     childrenClass: [
  //       {
  //         class: 'sct-links-conteiner',
  //         valueState: 'relatedLinks.cards',
  //         defaultValue: [],
  //         containerOneClass: 'sct-links-item',
  //         childrenClass: [
  //           {
  //             class: 'sct-links-btn',
  //             valueState: 'relatedLinks.cards[$index].$language.name',
  //             defaultValue: '',
  //             options: [
  //               { property: 'href', valueState: 'relatedLinks.cards[$index].btnHref', defaultValue: '_blank'  },
  //               { property: 'target', valueState: 'relatedLinks.cards[$index].btnTarget', defaultValue: ''  }
  //             ]
  //           },
  //         ],
  //       },
  //     ],
  //   }
  // },
  // {
  //   titleSection: 'Bloques de información (Tabla)',
  //   description: 'Agregar un conjunto de bloques de información que incluyan una imagen y una descripción',
  //   img: 'https://cdn.psdrepo.com/images/2x/daily-ui-004-how-it-works-o6.jpg',
  //   componentName: 'InformationBlocksTableForm',
  //   // containerClass: 'dynamic-elements-content',
  //   parentClass: {
  //     class: 'sct-blocks',
  //     childrenClass: [
  //       {
  //         class: 'sct-blocks-container',
  //         valueState: 'informationBlocks.cards',
  //         defaultValue: [],
  //         containerOneClass: 'sct-blocks-item',
  //         childrenClass: [
  //           { class: 'sct-blocks-item-title', valueState: 'informationBlocks.cards[$index].$language.title', defaultValue: '' },
  //           { class: 'sct-blocks-item-description', valueState: 'informationBlocks.cards[$index].$language.description', defaultValue: '', isCustomText: true },
  //           {
  //             class: 'sct-blocks-item-img',
  //             valueState: 'informationBlocks.cards[$index].backgroundImg',
  //             defaultValue: [],
  //             isImg: true,
  //           },
  //           {
  //             class: 'sct-blocks-item-link-icon',
  //             // valueState: 'carousel.cards[$index].$language.btnText',
  //             defaultValue: '<i class="fa fa-link">',
  //             isCustomText: true,
  //             // isRemove: true,
  //             // valueRemove: 'carousel.cards[$index].hasBnt',
  //             options: [
  //               { property: 'href', valueState: 'carousel.cards[$index].btnHref', defaultValue: '_blank'  },
  //               { property: 'target', valueState: 'carousel.cards[$index].btnTarget', defaultValue: ''  }
  //             ]
  //           },
  //           {
  //             class: 'sct-blocks-item-search-icon',
  //             // valueState: 'carousel.cards[$index].$language.btnText',
  //             defaultValue: '<i class="fa fa-search"></i>',
  //             isCustomText: true,
  //             // isRemove: true,
  //             // valueRemove: 'carousel.cards[$index].hasBnt',
  //             options: [
  //               { property: 'href', valueState: 'carousel.cards[$index].btnHrefSearch', defaultValue: '_blank'  },
  //               { property: 'target', valueState: 'carousel.cards[$index].btnTargetSearch', defaultValue: ''  }
  //             ]
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   titleSection: 'Bloques de información (Carousel)',
  //   description: 'Agregar un conjunto de bloques de información que incluyan una imagen y una descripción',
  //   img: 'https://user-images.githubusercontent.com/1037693/36797261-1d90f552-1c6d-11e8-9f67-18aa23bcb01e.PNG',
  //   componentName: 'InformationBlocksCarouselForm',
  //   // containerClass: 'dynamic-elements-content',
  //   parentClass: {
  //     class: 'sct-blocks-carrousel',
  //     childrenClass: [
  //       {
  //         class: 'sct-blocks-carrousel-container',
  //         valueState: 'informationBlocksCarousel.cards',
  //         defaultValue: [],
  //         containerOneClass: 'sct-blocks-carrousel-content-slider',
  //         isCarousel: true,
  //         optionCarousel : {
  //           itemsBySlider: 3,
  //           classIndicator: 'sct-blocks-carrousel-indicators',
  //           classitem: 'sct-blocks-carrousel-item'
  //         },
  //         childrenClass: [
  //           { class: 'sct-blocks-carrousel-item-title', valueState: 'informationBlocksCarousel.cards[$index].$language.title', defaultValue: '' },
  //           { class: 'sct-blocks-carrousel-item-description', valueState: 'informationBlocksCarousel.cards[$index].$language.description', defaultValue: '', isCustomText: true },
  //           {
  //             class: 'sct-blocks-carrousel-item-img',
  //             valueState: 'informationBlocksCarousel.cards[$index].backgroundImg',
  //             defaultValue: [],
  //             isImg: true,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // }
];

export const _catalogoClass = [
  {
    titleSection: 'Banner',
    description: 'Presenta una imagen, descripción, botones',
    img: 'https://static.vecteezy.com/system/resources/previews/000/271/404/non_2x/ux-ui-web-banner-vector.jpg',
    componentName: 'BannerForm',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'banner-section',
      childrenClass: [
        { class: 'banner-title', valueState: 'banner.$language.title', defaultValue: '' },
        { class: 'banner-description', valueState: 'banner.$language.description', defaultValue: '', isCustomText: true },
        {
          class: 'banner-btn-left',
          valueState: 'banner.$language.btnLeftText',
          defaultValue: '',
          isRemove: true,
          valueRemove: 'banner.hasBntLeft'
        },
        {
          class: 'banner-btn-rigth',
          valueState: 'banner.$language.btnRigthText',
          defaultValue: '',
          isRemove: true,
          valueRemove: 'banner.hasBntRigth'
        },
        {
          class: 'banner-background-img',
          valueState: 'banner.backgroundImg',
          defaultValue: [],
          isImg: true,
        },
      ],
    },
  },
  {
    titleSection: 'Acerca de nosotros',
    description: 'Agrega una descripción con formato para que los usuarios puedan saber de que se trata la sección',
    img: 'https://kiranworkspace.com/wp-content/uploads/edd/2020/12/service-section-1024x768.png',
    componentName: 'AboutForm',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'about-section',
      childrenClass: [
        { class: 'about-title', valueState: 'about.$language.title', defaultValue: '' },
        { class: 'about-description', valueState: 'about.$language.description', defaultValue: '', isCustomText: true },
      ],
    },
  },
  {
    titleSection: 'Nuestros servicios',
    description: 'Incluye a tu plantilla un listado de URLs que inviten al usuario a conocer más sobre el tema',
    img: 'https://cdn.psdrepo.com/images/2x/daily-ui-004-how-it-works-o6.jpg',
    componentName: 'OutServiceForm',
    containerClass: 'dynamic-elements-content',
    parentClass: {
      class: 'our-services-section',
      childrenClass: [
        { class: 'out-sevice-title', valueState: 'outService.$language.title', defaultValue: '' },
        {
          class: 'our-services-cards-content',
          containerOneClass: 'our-services-card',
          valueState: 'outService.$language.cards',
          defaultValue: [],
          isDinamyc: true,
          childrenClass: [
            { class: 'our-services-card-link', valueState: 'outService.$language.cards[$index].title', defaultValue: '', isLink: true, valueLink: 'outService.$language.cards[$index].link'},
            // { class: 'our-services-card-link', valueState: 'link', isLink: true },
            { class: 'our-services-card-description', defaultValue: '', valueState: 'outService.$language.cards[$index].description', isCustomText: true },
          ],
        },
      ],
    },
  },
];

export const prueba = 'sdsd'
